import React from 'react'

export default function Apropos() {
  return (
    <div className=' mt-28 text-zinc-600'>
      
      <section className='w-5/6 m-auto'>
        
        <h1 className='text-center mb-8'>Maître de Danse de Salon <br /> & <br />Spécialiste en Danses Latines et Standards</h1>

        <div className="flex flex-wrap justify-center items-start pt-8 pb-24 space-y-4 md:space-y-0 space-x-8">
  <img src="/img/kerenPre.jpg" alt="Image" className="lg:w-1/4 md:w-2/4 w-5/6 rounded " />
  <p className="text-start lg:w-1/4">
    En tant que professeure de danse, j’ai développé une expertise en danse folklorique et en chorégraphie.
    
    <br /><br /> J’adore transmettre cette richesse aux danseurs de tous niveaux, en m’adaptant aux besoins de chacun pour faire de la danse une expérience accessible et significative.
    <br /><br />
    
    <br /><br /> Grâce à des vidéos pédagogiques et des démonstrations que je partage en ligne, j’ai la chance de promouvoir la danse Latine, standard et Lady Style auprès d'un public mondial, en mêlant technique, expression personnelle et passion pour cet art.
  </p>
</div>


      <h1 className='text-center mt-16 mb-8'>Mon cursus</h1>
    <div className='space-y-2 my-8'>
        <h2 className='text-start'>Expérience professionnelle :</h2>
            <p>Depuis 2009 : Enseignant en danses latines et standards, formé selon la méthode IDTA (International Dancing Teachers Association) de Londres. <br />
            </p>
          <ul>Compétiteur international en danse sportive avec une solide expérience sur les scènes internationales :
            <li>2013 : Finaliste au Disney France Amateur Open (danses latines).</li>
            <li>2011 : Finaliste au WDSF Open Amateur Latin & Standard à Stuttgart.</li>
            <li>2012 : Finaliste en Latin & Standard au France Open Amateur.</li>
            <li>2009 : Finaliste au Russian Championship Latin professionnel amateur.</li>
            <li>2008 : Quart de finaliste amateur à Blackpool, Angleterre.</li>
          </ul>
    </div>

    <div className='space-y-2 my-8'>
      <h2>Enseignement :</h2>
        <ul>Formateur et professeur de danse au sein de plusieurs structures :
          <li>Associations en France.</li>
          <li>Créateur et directeur de ma propre école de danse.</li>
          <li>Enseignant à l'École des Arts du Spectacle "Beit Zvi".</li>
          <li>Professeur invité dans des écoles de danse en Angleterre et en France.</li>
        </ul>
    </div>

    <div className='space-y-2 my-8'>
      <h2>Artiste & Professeur International :</h2>
       <p>Invitée à enseigner et performer lors de festivals et congrès de danse à travers le monde.</p>
    </div>

    
      </section>
    </div>
  )
}
